import * as React from "react";
import { Header, Divider, Segment, Message } from "semantic-ui-react";

export const About = () => {
  return (

    <div>
      <Header as="h2">サイト一覧</Header>
      <Divider />

      <Segment>
        <Header as="h3">Webサイト</Header>
        <a href="https://ja.wayama.io/">https://ja.wayama.io/</a>
      </Segment>

      <Segment>
        <Header as="h3">経歴</Header>
        <a href="https://ja.wayama.io/about/">https://ja.wayama.io/about/</a>
      </Segment>

      <Segment>
        <Header as="h3">Github</Header>
        <a href="https://github.com/hiroshi0530/">https://github.com/hiroshi0530/</a>
      </Segment>

      {/* <Segment>
        <Header as="h3">Twitter</Header>
        <a href="https://twitter.com/HWayama/">https://twitter.com/HWayama/</a>
      </Segment> */}

      <Header as="h2">プロジェクト</Header>
      <Divider />
      <p>現在開発を行っているプロジェクト一覧です。</p>

      <Segment>
        <Header as="h3">LegalWin</Header>
        <a href="https://www.legalwin.jp/">https://www.legalwin.jp/</a>
      </Segment>

    </div>

  );
};

export default About;
